import React from "react";
import { Alert } from "@picklebet/ui";
import { Button } from "@picklebet/ui";
import { SlideOut } from "@/features/betslip/components/overlays/SlideOut";

import * as styles from "@/features/betslip/components/overlays/HeldBet.module.scss";

type HeldBetProps = {
  message: string;
  buttonLabel: string;
  testId: string;
};

/** The server is holding the bet — trader review, or a live delay. */
export const HeldBet = ({ message, buttonLabel, testId }: HeldBetProps) => (
  <SlideOut>
    <Alert
      className={styles.alert}
      color="info"
      data-testid={`overlay-${testId}`}
    >
      <span data-testid={`${testId}-message`}>{message}</span>
    </Alert>
    <div className={styles.footer}>
      <Button
        loading={true}
        variant="info"
        className={styles.button}
        data-testid={`${testId}-btn`}
      >
        {buttonLabel}
      </Button>
    </div>
  </SlideOut>
);
